module.exports = ".main-integrations {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.main-integrations a {\n  text-decoration: none;\n  color: #212529; }\n\n.card {\n  margin-left: 10%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/integrations/integrations.component.scss
// module id = ./src/app/components/integrations/integrations.component.scss
// module chunks = main